//@flow
import React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import TextInput from '../../../components/TextInput';
import messageManager from './../../../utilities/messageManager';
import DefaultButton from './../../../components/DefaultButton';
import GhostButton from './../../../components/GhostButton';
import loading from './../../../utilities/loading';

const FlexForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

const StyledPassword = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  width: 80%;
  flex-direction: column;
`;

const StyledMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 250px;
  display: ${props => props.visible ? 'block' : 'none'};
`;

const StyledErrorMessage = styled.div`
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin-bottom: 5px;
  color: #cf4444;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 15px;
`;

export let formInstance;

export class ChangePasswordModal extends React.Component {
    constructor() {
        super();

        this.state = {
            message: '',
            password: '',
            newPassword: '',
            repeatNewPassword: '',
            invalidPassword: false,
            invalidRepeatedPassword: false,
            changeButtonDisabled: false,
        };
    }

    handleInput(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSubmit() {
        const { password, newPassword, repeatNewPassword } = this.state;
        const { BASE_URL, changePasswordCallback, t, axiosInstance } = this.props;
        if (password === newPassword) {
            this.setState({
                message: t('New password must be different than the old one')
            });
            return;
        }
        if (newPassword !== repeatNewPassword) {
            this.setState({
                message: t('Passwords does not match')
            });
            return;
        }

        loading.start();
        this.setState({ changeButtonDisabled: true });

        axiosInstance.post(`${BASE_URL}account/change-password`, {
            login: this.props.userEmail,
            password: password,
            newPassword: newPassword
        })
            .then(response => {
                messageManager.show({
                    text: t('Password has been changed'),
                    type: 'info',
                });
                loading.stop();
                this.setState({ changeButtonDisabled: false });
                changePasswordCallback();
            })
            .catch(error => {
                loading.stop();
                this.setState({
                    changeButtonDisabled: false,
                    message: t('Invalid credentials')
                });
            });
    }

    handleCancel() {
        const { changePasswordCallback } = this.props;
        changePasswordCallback();
    }

    render() {
        const { message, password, newPassword, repeatNewPassword, invalidPassword, invalidRepeatedPassword, changeButtonDisabled } = this.state;
        const { t } = this.props;
        return (
            <ContentWrapper>
                <h3>{t('Change password')}</h3>
                <FlexForm onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleSubmit();
                }}>
                    <StyledPassword>
                        <TextInput
                            type="password"
                            placeholder={t('old password')}
                            required
                            name="password"
                            value={password}
                            onChange={event => {
                                this.handleInput(event);
                            }} />
                    </StyledPassword>
                    <StyledPassword>
                        <TextInput
                            type="password"
                            placeholder={t('new password')}
                            required
                            name="newPassword"
                            value={newPassword}
                            invalid={invalidPassword}
                            tip={t("Type 6 characters or more")}
                            onChange={event => {
                                this.handleInput(event);
                            }}
                            onBlur={event => {
                                if (newPassword.length < 6)
                                    this.setState({ invalidPassword: true })
                                else
                                    this.setState({ invalidPassword: false })
                            }} />
                    </StyledPassword>
                    <StyledPassword>
                        <TextInput
                            type="password"
                            placeholder={t('repeat new password')}
                            required
                            name="repeatNewPassword"
                            value={repeatNewPassword}
                            invalid={invalidRepeatedPassword}
                            tip={t("Type your password again")}
                            onChange={event => {
                                this.handleInput(event);
                            }}
                            onBlur={event => {
                                if (repeatNewPassword !== newPassword)
                                    this.setState({ invalidRepeatedPassword: true })
                                else
                                    this.setState({ invalidRepeatedPassword: false })
                            }} />
                    </StyledPassword>
                    <StyledMessage
                        visible={message !== ''}
                    >
                        <StyledErrorMessage>{t(message)}</StyledErrorMessage>
                    </StyledMessage>
                    <ButtonWrapper>
                        <GhostButton
                            style={{
                                height: '30px',
                                width: '70px',
                                marginRight: '5px',
                                fontSize: '14px',
                            }}
                            onClick={() => {
                                this.handleCancel();
                            }}
                        >
                            {t('Cancel')}
                        </GhostButton>
                        <DefaultButton
                            style={{
                                height: '30px',
                                width: '70px',
                                fontSize: '14px',
                            }}
                            disabled={changeButtonDisabled}
                            onClick={(e) => {
                                this.handleSubmit();
                            }}>
                            {t('Change')}
                        </DefaultButton>
                    </ButtonWrapper>
                </FlexForm>
            </ContentWrapper>
        );
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    userEmail: state.auth.get('userEmail'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ChangePasswordModal));


// WEBPACK FOOTER //
// ./src/containers/content/modal/ChangePasswordModal.jsx